import { Copy, GitBranch, Bell, Trash2, Mail, FileDown, MessageCircle, MoreHorizontal, ExternalLink } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator } from "./ui/dropdown-menu";
import styles from "../views/QuoteHistory.module.css";

export const QuoteHistoryActions = ({ item, isAdmin, busyRef, openQuote, duplicateQuote, reviseQuote,
  sendReminder, deleteQuote, sendToCustomer, downloadPdf, sendWhatsApp }) => {
  const ref = item.ref_code;
  const canEmail = !!item.customer_email;
  const menuItems = [
    { id: "open-quote", label: "Teklifi aç", icon: ExternalLink, action: openQuote },
    { id: "revise-quote", label: "Revize et", icon: GitBranch, action: reviseQuote },
    { id: "duplicate-quote", label: "Kopyala", icon: Copy, action: duplicateQuote },
    { id: "send-quote", label: "E-posta ile gönder", icon: Mail, action: sendToCustomer, disabled: !canEmail },
    { id: "reminder", label: busyRef === ref ? "Gönderiliyor…" : "Hatırlatma gönder", icon: Bell,
      action: sendReminder, disabled: !canEmail || !!item.customer_approval || busyRef === ref },
  ];
  return <div className={styles.actions} data-testid={`history-actions-${ref}`}>
    <button className={styles.actionButton} data-testid={`pdf-quote-${ref}`} aria-label="PDF indir" title="PDF indir"
      disabled={!downloadPdf} onClick={() => downloadPdf(ref)}><FileDown size={17} /></button>
    <button className={`${styles.actionButton} ${styles.whatsappButton}`} data-testid={`whatsapp-quote-${ref}`}
      aria-label="WhatsApp ile gönder" title="WhatsApp ile link + PDF gönder" disabled={!sendWhatsApp}
      onClick={() => sendWhatsApp(ref)}><MessageCircle size={17} /></button>
    <DropdownMenu>
      <DropdownMenuTrigger asChild><button className={styles.actionButton} data-testid={`history-more-${ref}`}
        aria-label={`${ref} diğer işlemler`} title="Diğer işlemler"><MoreHorizontal size={19} /></button></DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={7} collisionPadding={12} className={styles.menu} data-testid={`history-menu-${ref}`}>
        {menuItems.map(({ id, label, icon: Icon, action, disabled }) => <DropdownMenuItem key={id}
          className={styles.menuItem} data-testid={`${id}-${ref}`} disabled={disabled || !action}
          onSelect={() => action(ref)}><Icon size={15} />{label}</DropdownMenuItem>)}
        {isAdmin && deleteQuote && <>
          <DropdownMenuSeparator />
          <DropdownMenuItem className={`${styles.menuItem} ${styles.deleteItem}`} data-testid={`delete-quote-${ref}`}
            onSelect={() => deleteQuote(ref)}><Trash2 size={15} />Teklifi sil</DropdownMenuItem>
        </>}
      </DropdownMenuContent>
    </DropdownMenu>
  </div>;
};